export enum MissionType {
  Scan = 'Scan',
  Panorama = 'Panorama',
  GcpRequest = 'GCP Request',
  Other = 'Other',
}
